import { Spin } from "antd"
import "aos/dist/aos.css"
import "dayjs/locale/vi"
import "moment/locale/vi"
import React, { useEffect } from "react"
import "src/assets/scss/index.scss"
import "./App.scss"
import "./index.scss"
// Lazy load component nặng
const Provider = React.lazy(() => import("src/components/Provider"))
const DefaultAction = React.lazy(() =>
  import("src/components/Layouts/DefaultAction"),
)
const PrintPdfFromHtml = React.lazy(() =>
  import("src/components/PrintPdfFromHtml"),
)
const LoadingChunkFile = React.lazy(() =>
  import("./components/LoadingChunkFile"),
)
const AppRouter = React.lazy(() => import("./router/AppRouter"))

// Patch fetch để tự động include credentials
const originalFetch = window.fetch
window.fetch = function (input, init = {}) {
  if (!init.credentials) {
    init.credentials = "include"
  }
  return originalFetch(input, init)
}
export function LazyLoadingComponent({ children }) {
  return (
    <React.Suspense
      fallback={
        <div className="loading-center" style={{ height: "100vh" }}>
          <Spin />
        </div>
      }
    >
      {children}
    </React.Suspense>
  )
}
const App = () => {
  // Chặn double-click toàn trang web (800ms cooldown)
  useEffect(() => {
    const handleGlobalClick = e => {
      const btn = e.target.closest(
        'button, a, [role="button"], input[type="submit"], input[type="button"], .ant-btn, .btn'
      )
      if (btn && !btn.classList.contains("clicking-disabled")) {
        btn.classList.add("clicking-disabled")
        const originalPointerEvents = btn.style.pointerEvents
        btn.style.pointerEvents = "none"

        setTimeout(() => {
          btn.classList.remove("clicking-disabled")
          btn.style.pointerEvents = originalPointerEvents || ""
        }, 800)
      }
    }

    window.addEventListener("click", handleGlobalClick, true)
    return () => window.removeEventListener("click", handleGlobalClick, true)
  }, [])

  return (
    <LazyLoadingComponent>
      <Provider>
        <LazyLoadingComponent>
          <DefaultAction />
        </LazyLoadingComponent>

        <div className="layout-center">
          <div className="layout-max-width">
            <LazyLoadingComponent>
              <AppRouter />{" "}
            </LazyLoadingComponent>
          </div>
          <LazyLoadingComponent>
            <LoadingChunkFile />
          </LazyLoadingComponent>
          <LazyLoadingComponent>
            <PrintPdfFromHtml />
          </LazyLoadingComponent>
        </div>
      </Provider>
    </LazyLoadingComponent>
  )
}

export default App
